import "../../styles/components/common/selectElementComponent.css";

export const SelectElementComponent = ({ selectElementProps }) => {
  const { name, value, onChange, options, label, error, required, disabled, className, style, removeDefaultStyle } = selectElementProps;

  return (
    <div className={`${removeDefaultStyle ? "" : "selectContainer"} ${className}`} style={style}>
      {label && <label htmlFor={name}>{label}</label>}
      <select name={name} value={value} onChange={onChange} required={required} disabled={disabled} className={`select-element ${error ? "select-error" : ""}`}>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <span className="errorMessage">{error}</span>}
    </div>
  );
};

export default SelectElementComponent;
